import styled from '@emotion/styled';
import { Box, css, Grid, InputBase } from '@mui/material';
import { colors } from 'theme/colors';
import { boolean } from 'yup';

interface IImportFileContainer {
  disabled?: boolean;
  error?: boolean;
}
export const ImportFileContainer = styled(Grid)<IImportFileContainer>`
  width: 100%;
  min-height: 148px;
  row-gap: 12px;
  flex-direction: column;
  padding: 24px;
  align-content: center;
  border-width: 1px;
  border: 1px solid ${colors.gray400};
  border-style: dashed;
  dashes: 8, 8;
  border-radius: 4px;
  & > div {
    display: grid;
    justify-content: center;
    justify-items: center;
  }
  &:hover {
    border-color: ${colors.primary400};
    background: ${colors.primary15};
  }
  ${(props: IImportFileContainer) =>
    props.disabled &&
    css`
      border-color: ${colors.gray300};
      background: ${colors.gray50};
      & .MuiTypography-root {
        color: ${colors.gray300};
      }
    `}
  ${(props: IImportFileContainer) =>
    props.error &&
    css`
      border-color: ${colors.error800};
      & .MuiTypography-root {
        color: ${colors.error800};
      }
    `}
`;

interface IStyledFileInputContainer {
  disabledStyle?: boolean;
  disabled?: boolean;
}

export const StyledFileInputContainer = styled(Grid)<IStyledFileInputContainer>`
  border: 1px solid ${colors.gray300};
  border-radius: 4px;
  padding: 1px 12px;
  height: 32px;
  width: stretch;
  background: ${colors.white};
  gap: 8px;
  align-items: center;
  ${(props: IStyledFileInputContainer) =>
    props.disabledStyle &&
    css`
      background: ${colors.gray100};
    `}
`;
export const StyledFileInput = styled(InputBase)<IStyledFileInputContainer>`
  flex: 1;
  min-width: 0;
  padding-bottom: 3px;
  ${(props: IStyledFileInputContainer) =>
    !props.disabledStyle &&
    css`
      & .Mui-disabled {
        color: ${colors.black};
        -webkit-text-fill-color: ${colors.black}!important;
      }
    `}
  ${(props: IStyledFileInputContainer) =>
    props.disabledStyle &&
    css`
      color: ${colors.gray500} !important;
      '-webkit-text-fill-color':${colors.gray500}!important;
    `}
`;

export const StyledFileBox = styled(Box)`
  display: flex;
  alignitems: center;
  width: 100%;
`;

export const StyledFileType = styled.span`
  white-space: nowrap;
  color: ${colors.gray400};
  padding-top: 3px;
  font-size: 14px;
`;
